import script from "./option.vue?vue&type=script&setup=true&lang=ts"
export * from "./option.vue?vue&type=script&setup=true&lang=ts"

import "./option.vue?vue&type=style&index=0&id=64f33929&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64f33929"]])

export default __exports__